module.exports = __webpack_public_path__ + "static/media/progress33pctM.1c1fc9d0.jpg";